import React, { useCallback } from 'react';
import type { DOMNode } from 'html-dom-parser';
import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser';
import { Attributes } from 'html-react-parser/lib/attributes-to-props';

import { Link } from '@core/js/components/common/Link';
import { useSmartClosePopups } from '@core/js/components/common/PopupManager';

import { alignAttributesWithReact } from '@core/js/utils/getHTMLParserOptions.util';

export const useParseHtmlElements = () => {
    const closePopups = useSmartClosePopups();

    return useCallback((value: string): string | JSX.Element | JSX.Element[] => {
        const onClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
            event.stopPropagation();

            const target = event.target as HTMLAnchorElement;
            const isInTheSameWindow = target.target === '_self';

            if (isInTheSameWindow) {
                closePopups();
            }
        };

        const options = {
            replace: ({ attribs = {}, name, children }: { attribs: Attributes; name: string; children: DOMNode[]}) => {
                if (name === 'a') {
                    return (
                        <Link
                            onClick={onClick}
                            isDefaultLinkClass={false}
                            {...alignAttributesWithReact(attribs)}
                        >
                            {domToReact(children, options)}
                        </Link>
                    );
                }
            }
        } as HTMLReactParserOptions;

        return parse(value, options);
    }, [closePopups]);
};
